module.exports = __webpack_public_path__ + "assets/89090c52240a471a2f225fc6e2583df4.svg";